import { Link } from 'react-router-dom';
import { FaFacebook, FaYoutube, FaWhatsapp, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

export default function Footer() {
    return (
        <footer className="bg-gray-900 text-white py-8 sm:py-12">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                    {/* Brand Section */}
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="flex-shrink-0">
                                <img src="logo.png" alt="Logo" className="h-9 w-auto" />
                            </div>
                            <span className="text-2xl font-bold lemon-milk">Sudesh Maths</span>
                        </div>
                        <p className="text-gray-400 text-sm mb-4 poppins">
                            Excellence in Mathematics Education
                        </p>
                        <div className="flex gap-3">
                            <a href="https://web.facebook.com/sudesh.rathnayake.18" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                                <FaFacebook className="text-white text-sm" />
                            </a>
                            <a href="https://www.youtube.com/@maths_sudesh" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-600 rounded flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                                <FaYoutube className="text-white text-sm" />
                            </a>
                            <a href="https://wa.me/94719304566" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-blue-500 rounded flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                                <FaWhatsapp className="text-white text-sm" />
                            </a>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="font-bold text-lg mb-4 text-white lemon-milk">Contact</h3>
                        <div className="space-y-2 text-gray-400 text-sm poppins">
                            <p className="flex items-center gap-2">
                                <FaPhone className="text-blue-400" />
                                <span>071 930 4566</span>
                            </p>
                            <p className="flex items-center gap-2">
                                <FaPhone className="text-blue-400" />
                                <span>070 172 6095</span>
                            </p>
                            <p className="flex items-center gap-2">
                                <FaPhone className="text-blue-400" />
                                <span>076 858 2057</span>
                            </p>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="font-bold text-lg mb-4 text-white lemon-milk">Quick Links</h3>
                        <div className="space-y-2 text-gray-400 text-sm poppins">
                            <p><Link to="/" state={{ scrollTo: 'timetable' }} className="hover:text-blue-400 transition-colors">Time Tables</Link></p>
                            <p><Link to="/register" className="hover:text-blue-400 transition-colors">Enrollment</Link></p>
                            <p><Link to="/about" className="hover:text-blue-400 transition-colors">Contact Us</Link></p>
                            <p><Link to="/" state={{ scrollTo: 'timetable' }} className="hover:text-blue-400 transition-colors">Class Schedules</Link></p>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-500 text-sm poppins">&copy; 2025 Sudesh Maths. All rights reserved.
                        <a href="https://www.gimhan.me/" target="_blank" className="text-gray-500 hover:text-blue-400 transition-colors text-sm poppins">  GD Devolopments</a>
                    </p>
                    <div className="flex gap-6 mt-3 md:mt-0">
                        <Link to="/privacy" className="text-gray-500 hover:text-blue-400 transition-colors text-sm poppins">Privacy</Link>
                        <Link to="/terms" className="text-gray-500 hover:text-blue-400 transition-colors text-sm poppins">Terms</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
